var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDefaultSpaceFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H11.3431C12.404 0 13.4214 0.421427 14.1716 1.17157L16.8284 3.82843C17.5786 4.57857 18.596 5 19.6569 5H36C38.2091 5 40 6.79086 40 9V16H0V4Z",
    fill: "#41454B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 13.7909 1.79086 12 4 12H36C38.2091 12 40 13.7909 40 16V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V16Z",
    fill: "#30353B"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultSpaceFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-space-folder.af92c1ed97dabf72116b70e7015fdfb5.svg";